import { Stack } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { BankVerificationTable } from "Components/Verification/ToBeVerified/BankVerificationTable";
import { UserVerificationTable } from "Components/Verification/ToBeVerified/UserVerificationTable";

export default function ToBeVerifiedPage() {
  const { t } = useResource();

  return (
    <AuthenticatedLayout title={t(Resources.Pages.Titles.ToBeVerified)}>
      <StyledPageWrapper maxWidth="unset !important">
        <Stack gap={10}>
          <UserVerificationTable />
          <BankVerificationTable />
        </Stack>
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
}
